<template>
  <div 
    :class="containerClass"
    v-bind="$props"
  >
    <span 
      v-if="right"  
      :class="contextClass"
    >
      {{ label }}
    </span>
    <WorkIcon 
      v-else 
      :color="computedColor"
    >
      {{ icon }}
    </WorkIcon>
    <span 
      v-if="!right"  
      :class="contextClass"
    >
      {{ label }}
    </span>
    <WorkIcon 
      v-else 
      :color="computedColor"
    >
      {{ icon }}
    </WorkIcon>
  </div>
</template>

<script>
import WorkIcon from '@/components/global_components/icon/WorkIcon';

export default {
  name: 'WorkIconLabel',
  components: { WorkIcon },
  props: {
    icon: { type: String },
    label: { type: String },
    right: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false},
    color: { type: String, default: 'primary'}
  },
  computed: {
    containerClass() {
      return {
        'w-icon-label-container': true,
        'd-flex': true,
        'align-center': true,
        'disabled': this.disabled
      };
    },
    contextClass() {
      return {
        'w-icon-label': true,
        'w-icon-label--disabled': this.disabled
      };
    },
    computedColor() {
      return this.disabled ? 'textContent' : this.color;
    }
  },
};
</script>
<style lang="scss" scoped>
.w-icon-label {
  margin-left: 1rem;
}
</style>
